module.exports = __webpack_public_path__ + "static/media/featured-video-poster.47f30136.jpg";